// "show more" button functionality
const reviewsSection = document.querySelector('section > .reviews-section .reviews-section__container');
const reviews = document.querySelector('section > .reviews-section .reviews');
const showMoreBtn = document.querySelector('section > .reviews-section .reviews-show-more__btn');
const btnWrapper = document.querySelector('section > .reviews-section .button-wrapper');
const btnGradient = document.querySelector('section > .reviews-section .reviews-show-more');

// Cart page reviews section
const cartReviewsSection = document.querySelector('cart-items .reviews-section__container');
const cartReviews = document.querySelector('cart-items .reviews');
const cartShowMoreBtn = document.querySelector('cart-items .reviews-show-more__btn');
const cartBtnWrapper = document.querySelector('cart-items .button-wrapper');
const cartBtnGradient = document.querySelector('cart-items .reviews-show-more');

if (showMoreBtn) {
  showMoreBtn.onclick = () => {
    if (reviewsSection.classList.contains('reviews-section--expand')) {
      showMoreBtn.innerText = 'Show more';
      reviewsSection.classList.remove('reviews-section--expand');
      reviewsSection.style.height = '';
      btnWrapper.style.background = '';
      btnGradient.classList.remove("hidden")
    } else {
      reviewsSection.classList.add('reviews-section--expand');
      reviewsSection.style.height = `${reviews.getBoundingClientRect().height}px`;
      showMoreBtn.innerText = 'Show less';
      btnWrapper.style.background = 'rgba(255,255,255,.15)';
      btnGradient.classList.add("hidden")
    }
  };
}

if (cartShowMoreBtn) {
  cartShowMoreBtn.onclick = () => {
    console.log("Click!", cartBtnGradient);
    if (cartReviewsSection.classList.contains('reviews-section--expand')) {
      cartShowMoreBtn.innerText = 'Show more';
      cartReviewsSection.classList.remove('reviews-section--expand');
      cartReviewsSection.style.height = '';
      cartBtnWrapper.style.background = '';
      cartBtnGradient.classList.remove("hidden");
    } else {
      cartReviewsSection.classList.add('reviews-section--expand');
      cartReviewsSection.style.height = `${cartReviews.getBoundingClientRect().height}px`;
      cartShowMoreBtn.innerText = 'Show less';
      cartBtnWrapper.style.background = 'rgba(255,255,255,.15)';
      cartBtnGradient.classList.add("hidden");
    }
  };
}

// Show modal when clicking "write a review"

// Get the modal
const modal = document.getElementById('reviews__modal');

// Get the button that opens the modal
const createBtn = document.querySelector('.reviews-info__button');

const closeBtn = document.querySelector('.reviews__close');

if (createBtn && closeBtn) {
  // When the user clicks on the button, open the modal
  createBtn.onclick = function () {
    modal.classList.add('reviews__modal--open');
  };

  // When the user clicks on <span> (x), close the modal
  closeBtn.onclick = function () {
    modal.classList.remove('reviews__modal--open');
  };
  
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.classList.remove('reviews__modal--open');
    }
  };
}

// Review rating selector
let rating = 0;
const stars = Array.from(document.querySelectorAll('.reviews__star'));
function setStars(count) {
  stars
    .slice(0, count)
    .forEach((star) => star.classList.add('reviews__star--active'));
}

function clearStars() {
  stars
    .slice(rating)
    .forEach((star) => star.classList.remove('reviews__star--active'));
}

function setRating(event) {
  rating = event.target.value;
  clearStars();
}
